import { useEconomicCalendarHeroContent } from '../../../../hooks/useEconomicCalendarHeroContent';
import './Hero.css';

const Hero = () => {
  const { content, isLoading } = useEconomicCalendarHeroContent();

  if (isLoading || !content) {
    return null;
  }

  const { eyebrow, title, text } = content;

  return (
    <section className="economic-calendar-hero">
      <div className="economic-calendar-hero__inner">
        {eyebrow ? <p className="economic-calendar-hero__eyebrow">{eyebrow}</p> : null}
        <h1 className="economic-calendar-hero__title">{title}</h1>
        {text ? <p className="economic-calendar-hero__text">{text}</p> : null}
      </div>
    </section>
  );
};

export default Hero;
